import React from 'react'
import { Link } from 'react-router-dom'

export default function AcServicePriceSection() {
  const getOptimizedImg = (url, width = 1000) => {
    if (!url) return ''
    if (url.includes('assets.auxodev.dk') && !url.includes('/cdn-cgi/image/')) {
      return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=80,format=auto/`)
    }
    return url
  }

  const acGaugesImg = "https://assets.auxodev.dk/assets/6dac88dc-12c9-4e03-855a-45f8167172f2/imgi-19-bil-1-scaled.jpg"

  return (
    <section className="bg-white py-12 md:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 border-b border-slate-200">
      <div className="max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        
        {/* Left Column: Content */}
        <div className="lg:col-span-6 space-y-8">
          
          {/* Section 1: Price List Block */}
          <div className="space-y-4">
            <p className="text-xs font-black uppercase tracking-wider text-[#046BB4]">
              Erfaring og Ekspertise
            </p>
            
            <h2 className="text-2xl md:text-3xl lg:text-[28px] font-extrabold uppercase tracking-tight text-[#0A0A0A] leading-tight">
              A/C-Service – Faste lave priser:
            </h2>

            {/* Price Items */}
            <div className="space-y-4 pt-2">
              <div>
                <h3 className="text-base font-bold text-[#1C1917]">Benzin- og dieselbiler:</h3>
                <p className="text-sm md:text-base text-[#52525B]">649,- inkl. 100g kølemiddel</p>
                <p className="text-sm md:text-base text-[#52525B]">Herefter kun 2,- pr. gram ekstra.</p>
              </div>

              <div>
                <h3 className="text-base font-bold text-[#1C1917]">El- og hybridbiler:</h3>
                <p className="text-sm md:text-base text-[#52525B]">949,- inkl. 100g kølemiddel</p>
                <p className="text-sm md:text-base text-[#52525B]">Herefter kun 2,- pr. gram ekstra.</p>
              </div>

              <div>
                <h3 className="text-base font-bold text-[#1C1917]">Elbiler med CO₂-system:</h3>
                <p className="text-sm md:text-base text-[#52525B]">1799,- inkl. fuld påfyldning.</p>
              </div>
            </div>
          </div>

          {/* Section 2: About / Marketing Block */}
          <div className="space-y-4 pt-6 border-t border-slate-200">
            <h2 className="text-2xl md:text-3xl lg:text-[28px] font-extrabold uppercase tracking-tight text-[#0A0A0A] leading-snug">
              Dit lokale autoværksted i Varde – Sakskær Auto
            </h2>
            
            <div className="space-y-3 text-sm md:text-base text-[#52525B] leading-relaxed">
              <p>
                Vi er din lokale specialist i airconditionservice i Varde, og vi står klar til at hjælpe dig med både service, reparation og fejlfinding af bilens klimaanlæg. Vi lægger vægt på kvalitet, ærlighed og moderne udstyr – så du kan føle dig tryg hele vejen.
              </p>
              <p>
                Kontakt os i dag for at bestille tid til A/C-service – og kør med et klimaanlæg der virker!
              </p>
            </div>

            {/* Primary CTA */}
            <div className="pt-2">
              <Link 
                to="/kontakt/" 
                className="inline-block bg-[#046BB4] hover:bg-[#035590] text-white font-bold text-sm px-6 py-3.5 rounded-md transition-colors duration-200 shadow-sm tracking-wide"
              >
                Kontakt os i dag
              </Link>
            </div>
          </div>

        </div>

        {/* Right Column: Hero / Technical Image */}
        <div className="lg:col-span-6 h-full min-h-[380px] lg:min-h-[500px]">
          <div className="relative h-full w-full rounded-2xl md:rounded-3xl overflow-hidden shadow-xl border border-slate-200 bg-slate-100">
            <img 
              src={getOptimizedImg(acGaugesImg, 1000)} 
              alt="A/C Service påfyldning hos Sakskær Auto" 
              className="w-full h-full object-cover object-center min-h-[380px] lg:min-h-[520px]"
            />
          </div>
        </div>

      </div>
    </section>
  )
}
